module.exports = __webpack_public_path__ + "img/potato-3689642.dd88df36.jpg";